import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverArrow,
    PopoverCloseButton,
    IconButton,
    List,
    ListItem,
    Text,
    Flex,
    useColorMode,
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

const VariableHelpPopover = ({ predefinedVariables }) => {
    const { colorMode } = useColorMode();

    return (
        <Popover placement="bottom-start">
            <PopoverTrigger>
                <IconButton
                    icon={<InfoIcon />}
                    aria-label="Show predefined variables"
                    size="sm"
                    variant="ghost"
                />
            </PopoverTrigger>
            <PopoverContent
                bg={colorMode === 'light' ? 'gray.50' : 'gray.700'}
                borderColor={colorMode === 'light' ? 'gray.200' : 'gray.600'}
                p={0}
                width="100%"
                maxW="500px"
                boxShadow={colorMode === 'light' ? 'lg' : 'dark-lg'}
            >
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader
                    fontWeight="bold"
                    color={colorMode === 'light' ? 'gray.800' : 'white'}
                    borderBottomColor={colorMode === 'light' ? 'gray.200' : 'gray.600'}
                >
                    Predefined Variables
                </PopoverHeader>
                <PopoverBody p={0}>
                    <Flex direction="column" p={4}>
                        <Text
                            pt={3}
                            pb={3}
                            color={colorMode === 'light' ? 'gray.800' : 'white'}
                        >
                            <b>
                                These are the pre-defined variables that you can use in Initial Greeting Message or Instruction Prompt.
                            </b>
                        </Text>
                        <List
                            spacing={2}
                            color={colorMode === 'light' ? 'gray.700' : 'gray.200'}
                        >
                            {predefinedVariables.map((item) => (
                                <ListItem key={item.name}>
                                    {`<<${item.name}>> - ${item.description}`}
                                </ListItem>
                            ))}
                        </List>
                    </Flex>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
};

export default VariableHelpPopover;